import { render } from "./BeautyDetails.vue?vue&type=template&id=706417ae"
import script from "./BeautyDetails.vue?vue&type=script&lang=js"
export * from "./BeautyDetails.vue?vue&type=script&lang=js"

import "./BeautyDetails.vue?vue&type=style&index=0&id=706417ae&lang=less"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__